import { render, staticRenderFns } from "./facade-details-renders.vue?vue&type=template&id=5fc68b0d&"
import script from "./facade-details-renders.vue?vue&type=script&lang=js&"
export * from "./facade-details-renders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports